<router-outlet></router-outlet>
@if (loading$ | async) {
  <div class="overlay">
    <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
  </div>
}


  <div id="expired-popup-id" class="expired-popup-overlay">
    <div class="expired-popup">
      <div>Session expired, please log in</div>
      <div class="expired-popup-action"><a class="login-button" href="./login">Login</a></div>
    </div>
  </div>
